import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const magazineMvSlide = () => {
    const config = {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 1.5,
            },
            1024: {
                slidesPerView: 2,
            },
            1480: {
                slidesPerView: 2.25,
            },
        },
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        speed: 1000,
    };

    new Swiper('.jsMagazineMvSlide', config);
}
export { magazineMvSlide };